import { useEffect, useState } from "react";
import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { SkillListItem } from "../types";

interface UseSkillsListArgs {
  corporateId: string;
  initiativeId: number;
  page: number;
  pageSize: number;
  search?: string;
}

// ─── MOCK (rimuovere insieme a IS_MOCKED quando BE pronto) ─────────────
const IS_MOCKED = true;

const MOCK_SKILLS: SkillListItem[] = Array.from({ length: 17 }).map((_, i) => ({
  id: 9000 + i,
  name: `Skill ${i + 1}`,
  initiativeName: `Iniziativa ${(i % 3) + 1}`,
}));

const MOCK_DELAY = 300;

const useSkillsListMock = ({
  page,
  pageSize,
  search,
}: Pick<
  UseSkillsListArgs,
  "page" | "pageSize" | "search"
>): PaginatedListResult<SkillListItem> => {
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState<SkillListItem[]>([]);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    setIsLoading(true);
    const handle = setTimeout(() => {
      const filtered = search
        ? MOCK_SKILLS.filter((s) =>
            s.name.toLowerCase().includes(search.toLowerCase()),
          )
        : MOCK_SKILLS;
      const start = (page - 1) * pageSize;
      const end = start + pageSize;
      setItems(filtered.slice(start, end));
      setTotalItems(filtered.length);
      setIsLoading(false);
    }, MOCK_DELAY);
    return () => clearTimeout(handle);
  }, [page, pageSize, search]);

  return {
    items,
    totalItems,
    totalPages: Math.max(Math.ceil(totalItems / pageSize), 1),
    isLoading,
    error: null,
    mutate: () => {},
  };
};
// ───────────────────────────────────────────────────────────────────────

export const useSkillsList = ({
  corporateId,
  initiativeId,
  page,
  pageSize,
  search,
}: UseSkillsListArgs): PaginatedListResult<SkillListItem> => {
  const mockResult = useSkillsListMock({ page, pageSize, search });
  const url =
    !IS_MOCKED && corporateId && initiativeId
      ? ServicesURL.v2GetSkillsByInitiative
          .replace(":idCorporate", corporateId)
          .replace(":idInitiative", String(initiativeId))
      : null;
  const realResult = usePaginatedList<SkillListItem>(url, {
    page,
    pageSize,
    search,
  });
  return IS_MOCKED ? mockResult : realResult;
};
